//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { OrderbumpsContext } from "../context/OrderbumpsContext";
import { ContainerCustomTooltip } from "."
import { formatterDateDayMonth } from "../../../shared/utils";
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend, ResponsiveContainer } from "recharts";



//--------------- EXPORTAÇÃO DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
export default function ContainerGraphics() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { data, setData } = useContext(OrderbumpsContext); // Estado que armazena os Dados da busca feita pelo usuário



    //--------------- RETORNO CONDICIONAL DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
    return (
        <>
            {/* DIV PRINCPAIS POR DIA */}
            <div className="grid md:grid-cols-2 gap-6 mb-6 w-full">
                <div className="bg-surface-2 p-4 rounded-xl w-full border border-white/[0.08]">
                    <h2 className="text-lg font-semibold mb-2 text-brand-400">Principais por Dia</h2>
                    {data.principais_por_dia.length > 0
                        ?
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={data.principais_por_dia}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="dia" tickFormatter={formatterDateDayMonth} />
                                <YAxis />
                                <Tooltip content={<ContainerCustomTooltip />} />
                                <Legend />
                                <Line type="monotone" dataKey="quantidade" stroke="#8884d8" name="Principais" dot />
                            </LineChart>
                        </ResponsiveContainer>
                        :
                        <p className="text-gray-400 h-[80%] w-full flex justify-center items-center mb-10">Nenhuma transação principal encontrada</p>
                    }
                </div>

                {/* DIV ORDERBUMPS POR DIA */}
                <div className="bg-surface-2 p-4 rounded-xl w-full border border-white/[0.08]">
                    <h2 className="text-lg font-semibold mb-2 text-yellow-400">Orderbumps por Dia</h2>
                    {data.orderbumps_por_dia.length > 0
                        ?
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={data.orderbumps_por_dia}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="dia" tickFormatter={formatterDateDayMonth} />
                                <YAxis />
                                <Tooltip content={<ContainerCustomTooltip />} />
                                <Legend />
                                <Line type="monotone" dataKey="quantidade" stroke="#ffc658" name="Orderbumps" dot />
                            </LineChart>
                        </ResponsiveContainer>
                        :
                        <p className="text-gray-400 h-[80%] w-full flex justify-center items-center mb-10">Nenhuma transação orderbump encontrada</p>
                    }
                </div>
            </div>
        </>
    );
}
